import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const transformToBoolean = (value: boolean | string) :boolean => typeof value === 'string' ? value === '' : value;

@Component({
  selector: 'scw-shards-item',
  templateUrl: './item.component.pug',
  styleUrls: ['./item.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SCWShardsItemComponent,
    },
  ],
})
export class SCWShardsItemComponent implements ControlValueAccessor {
  @Input() shard;

  private _disabled: boolean = null;
  @Input() set disabled(value: boolean | string) {
    this._disabled = transformToBoolean(value);
  }
  get disabled(): boolean | string {
    return this._disabled;
  }

  @Input() max = 0;

  private _value: number;
  @Input() set value(value: number) {
    this.writeValue(value);
  }
  get value(): number {
    return this._value;
  }

  @Output() valueChange = new EventEmitter<number>();

  constructor() {
    // Noop.
  }

  protected onChangeCpu(value: number | string): void {
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }

    this._value  = value;
    this._emitChange(value);
  }

  private _onChange: any;
  private _onTouched: any;
  // START: ControlValueAccessor Interface
  public writeValue(value: any) {
    this._value = value;
  }

  public registerOnChange(fn: any) {
    this._onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this._onTouched = fn;
  }

  public setDisabledState?(disabled: boolean): void {
    this._disabled = transformToBoolean(disabled);
  }
  // END: ControlValueAccessor Interface

  private _emitChange(value: number): void {
    this.valueChange.emit(value);
    this._onChange && this._onChange(value);
  }
}
